export const subPermissionKeys = {
  groupKey: 'campus',

  read: 'campus-listar-sedes',
  create: 'campus-crear-sede',
  edit: 'campus-actualizar-sede',
  delete: 'campus-borrar-sede',
  //
}; // satisfies PermissionsKeys;
